import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";

const ClassificationInfoForm = ({ bookingsFieldsEnabled }) => {
  return (
    <>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={6}>
          <FormItem name="housedForAsOf" label="As Of">
            <CommonDatePicker
              showTime={false}
              disabled={!bookingsFieldsEnabled}
              format="MM/DD/YYYY"
            />
          </FormItem>
        </StyledGridCol>

        <StyledGridCol lg={4}>
          <FormItem name="needsClassification" label="Needs Classification">
            <Select
              options={getOptionsFromRefList("YesNoUnknown")}
              disabled={!bookingsFieldsEnabled}
            />
          </FormItem>
        </StyledGridCol>

        <StyledGridCol lg={6}>
          <FormItem name="nextClassification" label="Next Classification">
            <CommonDatePicker
              showTime={false}
              disabled={!bookingsFieldsEnabled}
              format="MM/DD/YYYY"
            />
          </FormItem>
        </StyledGridCol>

        <StyledGridCol>
          <FormItem
            name="inmateWorkerEvaluation"
            label="Inmate Worker Evaluation?"
            layout="horizontal"
            className="form-item-checkbox-left"
            style={{ marginBottom: "0", paddingTop: "30px" }}
            valuePropName="checked"
          >
            <Checkbox disabled={!bookingsFieldsEnabled} />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </>
  );
};
export default ClassificationInfoForm;
